import React from 'react';
import { Form } from 'react-bootstrap';
import { isMultiLocation, getLocationName, ALL_LOCATIONS_ID } from '../../util/locationUtils';

/**
 * Reusable location dropdown selector for reports and features
 * with independent location selection.
 *
 * Hidden when locations.length <= 1 (single-location installers).
 *
 * @param {Array} locations - Array of location objects
 * @param {string|number} selectedLocationId - Currently selected location ID
 * @param {function} onChange - Called with new locationId
 * @param {boolean} includeAll - Whether to include "All Locations" option (default: true)
 * @param {string} className - Additional CSS class
 */
const LocationSelector = ({ locations, selectedLocationId, onChange, includeAll = true, className = '' }) => {
  if (!isMultiLocation(locations)) return null;

  const handleChange = (e) => {
    const value = e.target.value;
    onChange(value === ALL_LOCATIONS_ID ? ALL_LOCATIONS_ID : value);
  };

  return (
    <Form.Control
      as="select"
      value={selectedLocationId || ALL_LOCATIONS_ID}
      onChange={handleChange}
      className={className}
      style={{ maxWidth: 250, display: 'inline-block' }}
    >
      {includeAll && <option value={ALL_LOCATIONS_ID}>All Locations</option>}
      {[...locations].sort((a, b) => getLocationName(a).localeCompare(getLocationName(b))).map(loc => (
        <option key={loc.location_id} value={loc.location_id}>
          {getLocationName(loc)}
        </option>
      ))}
    </Form.Control>
  );
};

export default LocationSelector;
